/**
 * Check if value is an array and return array, else return null.
 *
 * @param inputValue
 *
 * @returns {array|null}
 */
const returnArrayOrNull = (inputValue) => {
  if (Array.isArray(inputValue)) {
    if (inputValue.length > 0) {
      return inputValue
    }
  }

  return null
}

/**
 * Check if value is an string and return string, else return null.
 *
 * @param inputValue
 *
 * @returns {string|null}
 */
const returnStringOrNull = (inputValue) => {
  if (typeof inputValue === 'string') {
    if (inputValue.length > 0) {
      return inputValue
    }
  }

  return null
}

/**
 * Check if value is an number and return number, else return null.
 *
 * @param inputValue
 *
 * @returns {number|null}
 */
const returnNumberOrNull = (inputValue) => {
  if (typeof inputValue === 'number') {
    return inputValue
  }

  return null
}

/**
 * Check if value is an object and return object, else return null.
 *
 * @param inputValue
 *
 * @returns {object|null}
 */
const returnObjectOrNull = (inputValue) => {
  if (typeof inputValue === 'object') {
    if (inputValue !== null) {
      return inputValue
    }
  }

  return null
}

/**
 * Check if value is an boolean and return boolean, else return null.
 *
 * @param inputValue
 *
 * @returns {boolean|null}
 */
const returnBooleanOrNull = (inputValue) => {
  if (typeof inputValue === 'boolean') {
    return inputValue
  }

  return null
}

export {
  returnArrayOrNull,
  returnStringOrNull,
  returnNumberOrNull,
  returnObjectOrNull,
  returnBooleanOrNull,
}
